import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  FormGroup,
  Button,
  FormControl,
  ControlLabel,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { notebook as endpoints } from '../../api_urls'
import { useStateValue } from '../../state'
import { client } from '../../utils'
import HighlightActionMenu from './HighlightActionMenu'

const Highlight = props => {
  let [currentState, dispatch] = useStateValue()
  let [noteText, updateNoteText] = React.useState(props.note)

  const saveNoteText = async () => {
    let data = {
      ...currentState,
      hId: props.hId,
      noteText: noteText,
    }
    try {
      let resp = await client.post(endpoints.editNote(), data)
      dispatch({ type: 'updateHighlights', payload: resp.data.highlights })
      dispatch({
        type: 'editNote',
        payload: currentState.editingNote.filter(id => id !== props.hId),
      })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.message}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: false,
      })
    }
  }

  const cancelNoteEditing = () => {
    dispatch({
      type: 'editNote',
      payload: currentState.editingNote.filter(id => id !== props.hId),
    })
    updateNoteText(props.note)
  }

  return (
    <div id={`container-${props.hId}`} className="highlight-container">
      <div className="highlight-content-container">
        <HighlightActionMenu
          hId={props.hId}
          userIsOwner={props.userIsOwner}
          anchor={props.anchor}
          coursenum={currentState.coursenum}
        />
        <h2 className="h4">{props.sectionTitle}</h2>
        {props.tags && props.tags.length > 0 && (
          <React.Fragment>
            <div className="tag-container">
              {props.tags.map((tag, i) => (
                <a className="tag_button" key={i}>{`#${tag}`}</a>
              ))}
            </div>
            <br />
          </React.Fragment>
        )}
        <h3 className="h5">Highlighted Text:</h3>
        <p>
          <span
            className={props.contentString && props.cssClass}
            dangerouslySetInnerHTML={{
              __html:
                props.contentString ||
                `<i>
                  <sup>*</sup>
                  The highlighted text can&apos;t be displayed right now. You
                  can find out more
                  <a
                    href="https://myeducator.freshdesk.com/support/home"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  . You can navigate to the highlight through the Actions menu
                  above.
                </i>`,
            }}
          />
        </p>
        <hr />
        <div id={props.hId}>
          {!currentState.editingNote.includes(props.hId) ? (
            <React.Fragment>
              <h3 className="h5">Note:</h3>
              <p>{noteText || 'No note recorded.'}</p>
            </React.Fragment>
          ) : (
            <Form>
              <FormGroup>
                <ControlLabel>
                  <b>Note:</b>
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  placeholder="Type in your notes here."
                  value={noteText}
                  onChange={e => updateNoteText(e.target.value)}
                />
              </FormGroup>
              <div className="text-center">
                <Button
                  type="button"
                  bsStyle="primary"
                  className="btn-myed-sm btn-primary-myed"
                  onClick={saveNoteText}
                >
                  Save
                </Button>
                <Button
                  type="button"
                  bsStyle="default"
                  className="btn-myed-sm btn-default-myed"
                  onClick={cancelNoteEditing}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </div>
  )
}

Highlight.propTypes = {
  hId: PropTypes.string,
  cssClass: PropTypes.string,
  contentString: PropTypes.string,
  tags: PropTypes.array,
  anchor: PropTypes.string,
  userIsOwner: PropTypes.bool,
  note: PropTypes.string,
  sectionTitle: PropTypes.string,
}

export default Highlight
